// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { Sortable } from '@shopify/draggable';
//import Draggable, {DraggableCore} from 'react-draggable'; // Both at the same time
import { ajaxPerso, fetchBrands, handelize } from '../fnc'
import Select from 'react-select';
import {
	NavLink
} from 'react-router-dom';
import { prefix } from "@fortawesome/free-solid-svg-icons";
import ChangeImage from "./ctn/imageShopify/ChangeImage";
import AddBrandPageImage from "./ctn/imageShopify/AddBrandPageImage";
import AddImageToCdn from "./ctn/imageShopify/AddImageToCdn";
import AddMegaMenuCollectionImage from "./ctn/imageShopify/AddMegaMenuCollectionImage";
import store from 'store2';
const refConst = require("../constants.js").v

var initialState = {
	stores: [],
	_isMounted: false
}

const subCatPrefix = [
	"subCatIcon_",
	"flag_",
	"brandPage_",
	"logo_300x120_"
]

function ImagesShopify(props){

	const stores = refConst.stores.filter(o => {
		if(o.id_marketplace == 14)	return o
		return false
	})
	let objPreSelected = store("storeSelectedShImg")
	const [shopSelected, setShopSelected] = useState(objPreSelected? objPreSelected : stores[0]);

	const [shopifyStores, setShopifyStores] = useState([]);
	const [prefixSelected, setPrefixSelected] = useState(null);
	const [imagesData, setImagesData] = useState({imgs: [], info: null});
	const [coveragePrefixSelected, setCoveragePrefixSelected] = useState(null);
	const [coverageCheckLoading, setCoverageCheckLoading] = useState(false);
	const [coverageResult, setCoverageResult] = useState({
		checked: false,
		prefix: "",
		totalBrands: 0,
		totalImages: 0,
		missingBrands: []
	});

	useEffect(() => {
		initialState._isMounted = true;

		return () => initialState._isMounted = false
	}, [])

	useEffect(() => {
		if(refConst.stores.length > 0)
			setShopifyStores( refConst.stores.filter(o => {
				if(o.id_marketplace == 14)	return o
				return false
			}))
	}, [refConst.stores])

	useEffect(() => {
		if(!prefixSelected || !shopSelected.id)	return;
		props.loading(true);
		fetchImages({
			"shop": shopSelected.id,
			"filter_name": prefixSelected.value,
			"includeDetails": false
		}, (r) => {
			console.info('Result fetchImages', r);
			props.loading(false);
			if(r.errors)	props.info({"error": r.errors})
			setImagesData(r.success? {
				imgs: r.urlList,
				info: r.pageInfo
			} : {imgs: [], info: null})
		})
	}, [prefixSelected])

	const fetchImages = (args, callback) => {
		if(!initialState._isMounted)	return false
		ajaxPerso( Object.assign({
			"api": "shopify",
			"trigger": "get_admin_files",
			"autoLoad": false,
			"qty": 20,
		}, args), callback);
	}

	const fetchAllImagesFromPrefix = (prefixValue, callback, afterCursor = null, existingImgs = []) => {
		const reqData = {
			"shop": shopSelected.id,
			"filter_name": prefixValue,
			"includeDetails": false,
		};

		if(afterCursor)
			reqData.after = afterCursor;

		fetchImages(reqData, (r) => {
			if(r.errors) {
				callback({ errors: r.errors });
				return;
			}

			if(!r.success) {
				callback({ errors: ["Unable to fetch images"] });
				return;
			}

			const nextImgs = existingImgs.concat(r.urlList || []);
			if(r.pageInfo && r.pageInfo.hasNextPage && r.pageInfo.endCursor) {
				fetchAllImagesFromPrefix(prefixValue, callback, r.pageInfo.endCursor, nextImgs);
				return;
			}

			callback({ success: true, imgs: nextImgs });
		});
	}

	const loadMoreImages = () => {
		props.loading(true);
		fetchImages({
			"shop": shopSelected.id,
			"filter_name": prefixSelected.value,
			"includeDetails": false,
			"after": imagesData.info.endCursor
		}, (r) => {
			console.info('Result loadMoreImages', r);
			props.loading(false);
			if(r.errors)	props.info({"error": r.errors})
			else if(r.success){
				imagesData.imgs = imagesData.imgs.concat(r.urlList)
				imagesData.info = r.pageInfo
				setImagesData(Object.assign({}, imagesData))
			}
		})
	}

	const getBrandNameFromFileName = (imgObj, prefixValue = "") => {
		const fileName = imgObj?.fileName || imgObj?.filename || imgObj?.name || "";
		if(!fileName) return "";

		const selectedPrefix = prefixValue || "";
		let brandName = fileName;
		if(selectedPrefix && brandName.startsWith(selectedPrefix)) {
			brandName = brandName.substring(selectedPrefix.length);
		}

		return brandName.replace(/\.[^/.]+$/, "");
	}

	const runCoverageCheck = () => {
		if(!coveragePrefixSelected || !shopSelected?.id)	return;

		setCoverageCheckLoading(true);
		props.loading(true);

		fetchBrands(shopSelected.id, { onlyActive: true }, null, (brandsRes) => {
			if(brandsRes.error) {
				props.loading(false);
				setCoverageCheckLoading(false);
				props.info({ error: brandsRes.error });
				return;
			}

			const allBrands = (brandsRes.data || [])
				.map(o => o?.name || o?.brand_name || o)
				.filter(Boolean);

			fetchAllImagesFromPrefix(coveragePrefixSelected.value, (imgRes) => {
				props.loading(false);
				setCoverageCheckLoading(false);

				if(imgRes.errors) {
					props.info({ error: imgRes.errors });
					return;
				}

				const imageBrandSet = new Set(
					(imgRes.imgs || [])
						.map(o => getBrandNameFromFileName(o, coveragePrefixSelected.value))
						.filter(Boolean)
						.map(o => handelize(o))
				);

				const missingBrands = allBrands
					.filter(brandName => !imageBrandSet.has(handelize(brandName)))
					.sort((a, b) => `${a}`.localeCompare(`${b}`));

				setCoverageResult({
					checked: true,
					prefix: coveragePrefixSelected.value,
					totalBrands: allBrands.length,
					totalImages: (imgRes.imgs || []).length,
					missingBrands
				});
			});
		});
	}

	const showUp = () => {
		
		return <div className="border radius m-3 p-3 w-100 bg-light">
			<div className="mb-3 d-flex flex-row align-items-center justify-content-center">
				<span className="mr-4">Select one of our special prefix</span>
				<Select
					isClearable
					styles={refConst.styleList}
					onChange={(selectedOption) => {
						setPrefixSelected(selectedOption? selectedOption : null)
					}}
					options={(() => {
						let valueReturn = []
						subCatPrefix.forEach(prefix => {
							valueReturn.push( {
								value: prefix,
								label: prefix
							})
						})
						return valueReturn
					})()}
					value={prefixSelected? [prefixSelected] : null}
					isSearchable={true}
					isMulti={false}
					placeholder={"Image prefix"}
				/>
			</div>
			<div className="d-flex flex-wrap justify-content-center">
				{
					imagesData.imgs.map(o => {
						let sizeChoice = Math.max(o.height, o.width) > 150? "contain" : "auto"
						const brandName = getBrandNameFromFileName(o, prefixSelected?.value)
						return <div key={`${o.id}`} className="p-2 d-inline-block">
							<div className="" style={{backgroundImage: "url('"+o.url+"')", backgroundSize: sizeChoice, backgroundPosition: "center center", backgroundRepeat: "no-repeat", height: "150px", width: "150px"}}></div>
							<div className="mt-2 font-weight-bold">{brandName}</div>
							<div className="small text-muted">{o.date_created}</div>
						</div>
					})
				}
			</div>
			{imagesData.info && imagesData.info.hasNextPage? <div className="d-flex justify-content-center p-2"><button onClick={loadMoreImages}>Load More</button></div> : ""}
		</div>
	}

	const showCoverageCheck = () => {
		return <div className="border radius m-3 p-3 w-100 bg-light">
			<div className="mb-2 font-weight-bold">Brand image coverage checker</div>
			<div className="text-muted small mb-3">Pick a prefix and run the check. This scans all matching Shopify files in background and lists active brands that still do not have an image.</div>

			<div className="d-flex flex-row flex-wrap align-items-center">
				<div className="mr-3" style={{minWidth: "280px"}}>
					<Select
						isClearable
						styles={refConst.styleList}
						onChange={(selectedOption) => {
							setCoveragePrefixSelected(selectedOption? selectedOption : null)
						}}
						options={(() => {
							let valueReturn = []
							subCatPrefix.forEach(prefix => {
								valueReturn.push( {
									value: prefix,
									label: prefix
								})
							})
							return valueReturn
						})()}
						value={coveragePrefixSelected? [coveragePrefixSelected] : null}
						isSearchable={true}
						isMulti={false}
						placeholder={"Prefix for coverage check"}
					/>
				</div>
				<button className="btn btn-primary" disabled={!coveragePrefixSelected || coverageCheckLoading} onClick={runCoverageCheck}>
					{coverageCheckLoading? "Checking..." : "Run coverage check"}
				</button>
			</div>

			{coverageResult.checked? (
				<div className="mt-3">
					<div className="small text-muted mb-2">
						Prefix: <strong>{coverageResult.prefix}</strong> · Brands checked: <strong>{coverageResult.totalBrands}</strong> · Images scanned: <strong>{coverageResult.totalImages}</strong>
					</div>
					{coverageResult.missingBrands.length > 0? (
						<div>
							<div className="font-weight-bold mb-2">Brands without image ({coverageResult.missingBrands.length})</div>
							<div className="d-flex flex-wrap">
								{coverageResult.missingBrands.map(brand => <div key={brand} className="badge badge-light border m-1 p-2">{brand}</div>)}
							</div>
						</div>
					) : <div className="text-success font-weight-bold">All active brands have an image for this prefix.</div>}
				</div>
			) : ""}
		</div>
	}

	
	if(!props.securityClearance(props))	return "";
	
	return (
		<div className="main ctnPage container d-flex flex-row flex-wrap">
			<div className="input-group mb-4">
				<div className="input-group-prepend">
					<span className="input-group-text" id="basic-addon1">Website</span>
				</div>
				<select className="custom-select font-weight-bold" value={ shopSelected? JSON.stringify(shopSelected) : false } onChange={(e) => {
					store("storeSelectedShImg", JSON.parse(e.target.value))
					setShopSelected(JSON.parse(e.target.value))
				}}>
					{
						stores.length > 0? stores.map(o => {
							return <option key={o.name} value={JSON.stringify(o)}>{o.name}</option>
						}) : []
					}
				</select>
			</div>
			{showUp()}
			{showCoverageCheck()}
			<AddMegaMenuCollectionImage {...props} shop={shopSelected? shopSelected : null} />
			<ChangeImage {...props} shop={shopSelected? shopSelected : null} />
			<AddBrandPageImage {...props} shop={shopSelected? shopSelected : null} />
			<AddImageToCdn {...props} shop={shopSelected? shopSelected : null} />
		</div>
	);
}

export default ImagesShopify;